module.exports = __webpack_public_path__ + "static/media/u30_premium_contract6.332a59a0.webp";